<section>
	<header
		class="flex justify-between pb-4 border-b border-gray-200 sm:pb-0 mb-9 sm:border-none"
	>
		<div>
			<h2 class="text-xl font-bold leading-6 text-gray-900">
				{{ guideTitle() }}
			</h2>
		</div>
		<!-- swiper nav buttons -->
		<div class="flex items-center gap-3">
			<p class="ml-8 whitespace-nowrap" [ngClass]="pagination()"></p>
			<div class="hidden gap-3 sm:flex">
				<button
					type="button"
					data-toggle="tab"
					role="tab"
					aria-label="Prev"
					[ngClass]="prev()"
					class="bg-white carousel-navigation swiper-button-prev swiper-button-prev-campus swiper-no-swiping"
				></button>
				<button
					type="button"
					data-toggle="tab"
					role="tab"
					aria-label="Next"
					[ngClass]="next()"
					class="bg-white carousel-navigation swiper-button-next swiper-button-next-campus swiper-no-swiping"
				></button>
			</div>
		</div>
	</header>
	<div class="-mx-5">
		<div class="!px-5">
			<swiper-container #swiperRef init="false">
				@for (guide of guides(); track guide.id) {
					<swiper-slide class="swiper-slide">
						<uc-guides-card
							[categoryGuide]="categoryGuide()"
							[categoryUrl]="categoryUrl()"
							[guide]="guide"
						/>
					</swiper-slide>
				}
				<swiper-slide class="swiper-slide">
					<div
						class="flex justify-center w-full h-full px-4 text-center border border-gray-200 shadow-xs bg-gray-50 rounded-xl"
					>
						<a
							class="flex items-center justify-center py-16 swiper-no-swiping"
							[routerLink]="['/guides', categoryUrl()]"
						>
							<span class="text-2xl font-bold text-gray-600">
								View All Guides
							</span>
							<uc-ringed-right-arrow-svg />
						</a>
					</div>
				</swiper-slide>
			</swiper-container>
		</div>
	</div>
</section>
